/**
 * @desc 根据入参条件查询用户列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.LaborConditionsQuery,
): Promise<defs.StandardReturn<defs.Pager<defs.LabourDTO>>> {
  return defHttp.post({
    url: '/web/labour/query',
    data,
  });
}

export function mock(
  data: defs.LaborConditionsQuery,
): Promise<defs.StandardReturn<defs.Pager<defs.LabourDTO>>> {
  return defHttp.post({
    url: '/mock/web/labour/query',
    data,
  });
}
